import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { IWorkersTimesheet } from '@/modules/workforce/workersTimesheet/types';
import axiosClient from '@/shared/lib/axios';

const getAttendanceSummary = async (
  params: IWorkersTimesheet.IGetAttendanceSummarySchema
): Promise<IWorkersTimesheet.IGetAttendanceSummaryResponse> => {
  const { data } = await axiosClient.get(
    '/company/portalInsights/daily-attendance/summary',
    {
      params,
    }
  );
  return data;
};

export const useGetAttendanceSummary = (
  params: IWorkersTimesheet.IGetAttendanceSummarySchema
) => {
  return useQuery(
    ['getAttendanceSummary', params],
    () => getAttendanceSummary(params),
    {
      enabled: Boolean(params.entityId) && Boolean(params.date),
    }
  );
};
/****************************** sheet table ************************************ */
const getAttendanceTimesheet = async (
  params: IWorkersTimesheet.IGetAttendanceTimesheetSchema
): Promise<IWorkersTimesheet.IGetAttendanceTimesheetResponse> => {
  const { data } = await axiosClient.get(
    '/company/portalInsights/daily-attendance/workers',
    {
      params,
    }
  );
  return data;
};

export const useGetAttendanceTimesheet = (
  params: IWorkersTimesheet.IGetAttendanceTimesheetSchema
) => {
  return useQuery(
    ['getAttendanceTimesheet', params],
    () => getAttendanceTimesheet(params),
    {
      enabled: Boolean(params.entityId) && Boolean(params.date),
    }
  );
};
/****************************** review worker ************************************ */
const getReviewWorker = async (
  params: IWorkersTimesheet.IGetReviewWorkerSchema
): Promise<IWorkersTimesheet.IGetReviewWorkerResponse> => {
  const { data } = await axiosClient.get(
    '/company/portalInsights/daily-attendance/review-worker',
    {
      params,
    }
  );
  return data;
};

export const useGetReviewWorker = (
  params: IWorkersTimesheet.IGetReviewWorkerSchema
) => {
  return useQuery(['getReviewWorker', params], () => getReviewWorker(params), {
    enabled:
      Boolean(params.entityId) &&
      Boolean(params.date) &&
      Boolean(params.workerId),
  });
};
/****************************** verify worker ************************************ */

interface IVerifyIdentityProps {
  attendanceActionType: IWorkersTimesheet.IAttendanceActionType;
}

export const useVerifyIdentity = ({
  attendanceActionType,
}: IVerifyIdentityProps) => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: IWorkersTimesheet.IVerifyIdentitySchema) => {
      return axiosClient.post(
        `/company/portalInsights/daily-attendance/${attendanceActionType}`,
        data
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['getAttendanceTimesheet']);
        queryClient.invalidateQueries(['getAttendanceSummary']);
      },
    }
  );
};
